import { TFunction } from 'i18next';
import { Level } from '../../../entities';
import { IStep } from '../data/NewUserConstants';

export const buildNewUserPath = (path = ''): string => {
  return '/user-management/users/new-user' + path;
};

export const arePreviousStepsValid = (validSteps: number[], currentStepNumber: number): boolean => {
  let valid = true;

  if (currentStepNumber !== 1) {
    for (let i = 1; i < currentStepNumber; i++) {
      if (!validSteps.includes(i)) {
        valid = false;
      }
    }
  }

  return valid;
};

export const redirectToLastValidStep = (
  allSteps: IStep[],
  validSteps: number[],
  push: (href: string) => void,
): void => {
  if (validSteps.length === 0) {
    push(buildNewUserPath(allSteps[0].route));
  } else {
    const lastValidStep = Math.max(...validSteps);

    push(buildNewUserPath(allSteps[lastValidStep].route));
  }
};

export const getLevelText = (level: Level, t: TFunction): string => {
  switch (level) {
    case 'Group':
      return t('newUser.levels.group');
    case 'Brand':
      return t('newUser.levels.brand');
    case 'Site':
      return t('newUser.levels.site');
    case 'MultiSite':
      return t('newUser.levels.multisite');
    default:
      return t('newUser.levels.salecycle');
  }
};
